export default __webpack_public_path__ + "static/media/Sash of the Bloodhunter.cef24350.jpg";